<template>
	<router-view></router-view>
</template>

<script>
	import("pwacompat");
	export default {
		name: "App",

		components: {},

		data() {
			return {
				deferredPrompt: null,
			};
		},
	};
</script>


